import { snakeToCamel } from './snakeToCamel'

export function snakeToCamelCase(obj: unknown): void {
  if (!obj) {
    return
  }

  if (Array.isArray(obj)) {
    obj.map(snakeToCamelCase)

    return
  }

  if (obj?.constructor === Object) {
    for (const [key, value] of Object.entries(obj)) {
      delete obj[key]

      obj[snakeToCamel(key)] = value

      snakeToCamelCase(value)
    }
  }
}
